import api from "api";
import { useCallback, useState } from "react";

export default function useFetchHealthPlan() {
  const [hp, sethp] = useState(null);

  const fetchHealthPlan = useCallback(
    async (hpCode) => {
      try {
        const res = await api.healthPlanList.fetchHealthPlan(hpCode);
        sethp(res.data);
      } catch (e) {
        console.log(e.message);
      }
    },
    [sethp]
  );

  return [hp, fetchHealthPlan];
}
